import React, { Component } from 'react';
import { NavigateFunction } from 'react-router-dom';
import { withTranslation, WithTranslation } from "react-i18next";
import './LeaveRequestTypePage.css';
import i18n from '../../../i18n';
import { ReactComponent as ArrowLeft } from '../../../assets/icons/arrow-left.svg';

const t = i18n.t;

interface LeaveRequestTypePageProps extends WithTranslation {
  navigate: NavigateFunction;
  location?: any;
}

interface LeaveRequestTypePageState {
  selected: number;
  listTypes: Array<{
    id: number;
    type: string;
  }>;
  code: string;
  categoryId: number | null;
}

class LeaveRequestTypePage extends Component<LeaveRequestTypePageProps, LeaveRequestTypePageState> {
  constructor(props: LeaveRequestTypePageProps) {
    super(props);
    
    // Extract parameters from URL query parameters (consistent with other pages)
    const urlParams = new URLSearchParams(window.location.search);
    
    const code = urlParams.get('code');
    const categoryId = urlParams.get('categoryId') ? parseInt(urlParams.get('categoryId')!) : null;
    
    // Ensure code is always present (should be passed from previous screen)
    if (!code) {
      console.error('LeaveRequestTypePage: code parameter is required but not provided');
      // Fallback to prevent app crash, but this should not happen in normal flow
    }
    
    this.state = {
      selected: 1,
      listTypes: [
        { id: 1, type: "Student leave" },
        { id: 2, type: "Therapist leave" },
      ],
      code: code || '',
      categoryId: categoryId,
    };
  }

  _onNextPress = () => {
    const { selected, code } = this.state;
    const { navigate } = this.props;
    
    // Navigate to LeaveRequestBookMakeUpSessionPage with parameters (using query params like other pages)
    const params = new URLSearchParams({
      categoryId: selected.toString(),
      code: code!,
      isStudent: (selected === 1).toString(),
      isTherapist: (selected === 2).toString(),
    });
    
    navigate(`/calendar/leave-request-makeup-session?${params.toString()}`);
  };

  render() {
    const { selected, listTypes } = this.state;

    return (
      <div className="leaverequesttype-page">
        {/* Header */}
        <div className="page-header">
          <div className="page-header-inner">
            <div className="header-left">
              <button className="header-button" onClick={() => this.props.navigate(-1)}>
                <ArrowLeft />
              </button>
              <h1 className="header-title">
                {String(t?.('leave-request-history:choose-leave-type') || 'Choose Leave Type')}
              </h1>
            </div>
            <div className="header-right">
              <button 
                className="header-button next-button" 
                onClick={this._onNextPress}
                disabled={!selected}
              >
                <span>{String(t?.('select-booking-category-screen:header.right') || 'Next')}</span>
              </button>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="page-content">
          <div className="leave-type-list">
            {listTypes.map((item) => (
              <div 
                key={item.id} 
                className="leave-type-item"
                onClick={() => this.setState({ selected: item.id })}
              >
                <div className="leave-type-content">
                  <div className="leave-type-info">
                    <span className="leave-type-name">{item.type}</span>
                  </div>
                  <div className="radio-selection">
                    {selected === item.id ? (
                      <span className="radio-selected"></span>
                    ) : (
                      <span className="radio-unselected"></span>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(LeaveRequestTypePage);
